import {
  Box, HStack, Text,
  Wrap,
} from '@chakra-ui/react';
import { TRAFFIC_LIGHT_COLOURS } from '../shared/constants';

const colorOrder = [TRAFFIC_LIGHT_COLOURS.GREEN, TRAFFIC_LIGHT_COLOURS.YELLOW, TRAFFIC_LIGHT_COLOURS.ORANGE, TRAFFIC_LIGHT_COLOURS.RED, TRAFFIC_LIGHT_COLOURS.GREY];

function sortItemsByColor(items) {
  return items.sort(
    (a, b) => colorOrder.indexOf(a.color) - colorOrder.indexOf(b.color),
  );
}

function IndicatorLegend({ items, rest }) {
  const sortedItems = sortItemsByColor(items);

  return (
    <Wrap
      justify="center"
      spacing={2}
      px={2}
      {...rest}
    >
      {sortedItems.map((item, index) => (
        <HStack key={index} align="center" spacing={2}>
          <Box backgroundColor={item.color} boxSize={2} borderRadius="full" flexShrink={0} className="legend-indicator" />
          <Text fontSize="xs" className="legend-label">{item.label}</Text>
        </HStack>
      ))}
    </Wrap>
  );
}

export default IndicatorLegend;
